module.exports = __webpack_public_path__ + "img/viewMore.f200c698.svg";